export default __webpack_public_path__ + "static/media/promptPay2.cfbb1d28.png";